import {
	confirmTreasuryItemProductSuccess,
	getTreasuryProductDataErrorAction,
	getTreasuryProductDataSuccess,
	loadingTreasuryItemSuccess,
	updateTreasuryProductDataErrorAction,
	updateTreasuryProductDataSuccess
} from 'actions'
import {
	confirmTreasuryItemProductApi,
	getTreasuryProductDataApi,
	loadingTreasuryItemApi,
	updateTreasuryProductDataApi
} from 'api/IndividualTreasuryItem'
import { IndividualTreasuryItemActions } from 'constants/ActionsTypesTs'
import {
	IConfirmTreasuryItemProductAction,
	IGetTreasuryProductDataAction,
	IGetTreasuryProductDataResponse,
	ILoadingTreasuryItemAction,
	IUpdateTreasuryProductDataAction,
	IUpdateTreasuryProductDataResponse
} from 'models/IndividualTreasuryItem'
import { IResponseResult } from 'models/ResultsInterface'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'

function* loadingTreasuryItemRequest({
	payload
}: ILoadingTreasuryItemAction): any {
	try {
		const total = yield call(loadingTreasuryItemApi, payload)
		yield put(loadingTreasuryItemSuccess(total))
	} catch (error) {}
}

function* getTreasuryProductDataRequest({
	payload
}: IGetTreasuryProductDataAction): any {
	try {
		const product: IGetTreasuryProductDataResponse = yield call(
			getTreasuryProductDataApi,
			payload
		)
		yield put(getTreasuryProductDataSuccess(product))
	} catch (error: any) {
		yield put(getTreasuryProductDataErrorAction(error))
	}
}

function* updateTreasuryProductDataRequest({
	payload
}: IUpdateTreasuryProductDataAction): any {
	try {
		const product: IUpdateTreasuryProductDataResponse = yield call(
			updateTreasuryProductDataApi,
			payload
		)
		yield put(updateTreasuryProductDataSuccess(product))
	} catch (error: any) {
		yield put(updateTreasuryProductDataErrorAction(error))
	}
}

function* confirmTreasuryItemProductRequest({
	payload
}: IConfirmTreasuryItemProductAction): any {
	const { params, callBackReturn } = payload

	try {
		const confirm: IResponseResult = yield call(
			confirmTreasuryItemProductApi,
			params
		)
		if (callBackReturn) {
			callBackReturn()
		}
		yield put(confirmTreasuryItemProductSuccess(confirm))
	} catch (error: any) {}
}

export function* loadingTreasuryItemSaga() {
	yield takeLatest(
		IndividualTreasuryItemActions.LOADING_TREASURY_ITEM,
		loadingTreasuryItemRequest
	)
}

export function* getTreasuryProductDataSaga() {
	yield takeLatest(
		IndividualTreasuryItemActions.GET_TREASURY_PRODUCT_DATA,
		getTreasuryProductDataRequest
	)
}

export function* updateTreasuryProductDataSaga() {
	yield takeLatest(
		IndividualTreasuryItemActions.UPDATE_TREASURY_PRODUCT_DATA,
		updateTreasuryProductDataRequest
	)
}

export function* confirmTreasuryItemProductSaga() {
	yield takeLatest(
		IndividualTreasuryItemActions.CONFIRM_TREASURY_ITEM_PRODUCT,
		confirmTreasuryItemProductRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(loadingTreasuryItemSaga),
		fork(getTreasuryProductDataSaga),
		fork(updateTreasuryProductDataSaga),
		fork(confirmTreasuryItemProductSaga)
	])
}
